import { ArrowRight, BookOpen } from "lucide-react";
import { Link } from "wouter";

export type SeriesGuideLinkProps = {
  part: number;
  title: string;
  slug: string;
};

/** Contextual service-to-guide bridge for the From Prompt to Profit series. */
export default function SeriesGuideLink({ part, title, slug }: SeriesGuideLinkProps) {
  return (
    <section
      className="mx-auto max-w-7xl px-5 py-6 sm:px-8"
      aria-label="Related implementation guide"
    >
      <div className="flex flex-col gap-4 rounded-2xl border border-emerald-500/25 bg-slate-950 px-5 py-5 shadow-[0_12px_36px_rgba(2,6,23,0.24)] sm:flex-row sm:items-center sm:justify-between sm:px-7">
        <div className="min-w-0">
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-emerald-300">
            <BookOpen className="h-4 w-4" aria-hidden="true" />
            From Prompt to Profit · Part {part}
          </p>
          <h2 className="mt-2 text-lg font-bold text-white sm:text-xl">{title}</h2>
          <p className="mt-1 max-w-3xl text-sm leading-6 text-slate-300">
            Read the evidence-led implementation guide alongside this service page.
          </p>
        </div>
        <Link
          href={`/blog/${slug}/`}
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-lg bg-emerald-400 px-4 py-3 text-sm font-bold text-slate-950 transition-transform duration-150 hover:bg-emerald-300 active:scale-[0.97]"
        >
          Read the guide <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
}
